import styled from "styled-components";

const FeedStyle = styled.div`
  svg {
    font-size: 20px;
    margin-right: 5px;
  }
  .feedcard {
    padding: 1rem;
    margin: 1rem 0;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0px 4px 19px 4px rgba(34, 60, 80, 0.2);
    transition: all 1s ease-in-out;
    align-items: center;
    &:hover {
      box-shadow: 0px 10px 20px 15px rgba(34, 60, 80, 0.22);
    }
  }
  button:hover {
    color: #fff;
  }
  .deactivated {
    display: none !important;
  }
  .btn-outline-info:hover {
    color: #fff !important;
  }
  .text-color-info {
    color: rgb(34, 207, 241);
  }
`;
export default FeedStyle;



// WEBPACK FOOTER //
// ./src/Components/Feedback/FeedChildStyles.js